import React, { useRef, useState } from "react";
import useDataFetcher from "../../../../common-deprecated/hooks/useDataFetcher";
import type { GetFetchesFnType } from "../../../../common-deprecated/utils/registryTypes";
import { COMPONENT_USED_STOCK_CARS } from "../../../../shared-logic/server/components";
import useUscInsuranceInit from "../../hooks/useUscInsuranceInit";
import useUscFinanceInit from "../../hooks/useUscFinanceInit";
import { useUscSelector } from "../../redux/store";
import NotificationContainer from "../../../shared-components/toyota/floating-elements/modals/notifications/NotificationContainer";
import { getUscComponentFetches, uscFetchDispatcher } from "../../datafetch/fetchUtils";
import uscPostFetch from "../../datafetch/postFetch";
import { UscNavStepEnum } from "../../utils/constants";
import PdpContainer from "./pdp/PdpContainer";
import ExtrasContainer from "./extras/ExtrasContainer";
import MobileFooter from "./common/MobileFooter";
import useUsedStockCars from "../../hooks/useUsedStockCars";
import useUscExternalPriceInit from "../../hooks/useUscExternalPriceInit";
import useUscCarDeliveryInit from "../../hooks/useUscCarDeliveryInit";
import GlobalStyle from "../../../shared-components/toyota/styles/Global.styles";
import PageDisclaimers from "./common/PageDisclaimers";
import { useWindowDimensionsContext } from "../../../../common-deprecated/containers/WindowDimensionsProvider";
import { useIsomorphicLayoutEffect } from "../../../../common-deprecated/hooks/useIsomorphicLayoutEffect";

const UsedStockCars = (): JSX.Element => {
    const step = useUscSelector((state) => state.nav.step);
    const [contentWidth, setContentWidth] = useState<number>(0);
    const [contentSpacing, setContentSpacing] = useState<number>(0);
    const containerRef = useRef<{ getContentWidth: () => number }>(null);
    const windowWidth = useWindowDimensionsContext().width;
    const MAX_CONTAINER_WIDTH = 1440;

    useDataFetcher(
        getUscComponentFetches as unknown as GetFetchesFnType,
        uscFetchDispatcher,
        COMPONENT_USED_STOCK_CARS,
        [],
        ["uscEnv", "brand"],
        uscPostFetch,
    );

    useUsedStockCars();
    // init price integrations
    useUscInsuranceInit();
    useUscFinanceInit();
    useUscExternalPriceInit(step === UscNavStepEnum.Pdp);
    useUscCarDeliveryInit(step === UscNavStepEnum.Extras);

    useIsomorphicLayoutEffect(() => {
        if (containerRef.current) {
            setContentWidth(containerRef.current.getContentWidth());

            if (windowWidth >= 1600) {
                const containerSpacing = windowWidth - MAX_CONTAINER_WIDTH;
                setContentSpacing(containerSpacing / 2);
            }
        }
    }, [step, windowWidth]);

    return (
        // This ID is used in Global.styles to scope global overrides in the Toyota CSS
        <>
            <GlobalStyle />
            {step === UscNavStepEnum.Pdp ? <PdpContainer ref={containerRef} /> : <ExtrasContainer />}
            <PageDisclaimers />
            <MobileFooter />
            <NotificationContainer contentWidth={contentWidth} contentSpacingLeft={contentSpacing} />
        </>
    );
};

export default UsedStockCars;
